import { MobileProposalExpirationDatesResponseDTO } from "@repo/core/services/entities/MobileProposal";
import { ConsultProposalResponseDTO } from "@repo/core/services/entities/Proposals";
import { AxiosInstance, AxiosResponse } from "axios";

const resourcePrefix = "/PropostaMobile";

export class MobileProposalResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }
  async fetchInvoiceExpirationDates(
    strProduto: string
  ): Promise<AxiosResponse<MobileProposalExpirationDatesResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarDiasVencimento?strProduto=${strProduto}`
    );
  }

  async getCompleteProposal(
    lngProposta: string
  ): Promise<AxiosResponse<ConsultProposalResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarProposta?lngProposta=${lngProposta}`
    );
  }
}
